module.exports = __webpack_public_path__ + "img/box_pro_one_1.4d908fed.jpg";